import React from "react";
import Chat from "components/chat";
import { Modal } from "@mui/material";

const ChatModal = (props) => {
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    boxSizing: "border-box",
    width: "500px",
    background: "white",
    outline: "none",
    border: "2px solid #cd3367",
  };
  return (
    <Modal onClose={props.onClose} open={true}>
      <div style={modalStyle}>
        <Chat
          firstName={props.consumerFirstName}
          lastName={props.consumerlastName}
          memeberUuid={props.uuid}
        />
      </div>
    </Modal>
  );
};

export default ChatModal;
